// Simple console-based logger for frontend
// Info logs only in development; warnings and errors always shown
const logger = {
  info: (...args) => {
    if (import.meta.env.DEV) console.log('[INFO]', ...args);
  },
  warn: (...args) => console.warn('[WARN]', ...args),
  error: (...args) => console.error('[ERROR]', ...args)
};

export { logger };
export default logger;
